module.exports = __webpack_public_path__ + "static/media/icon-cross.d390b0fd.svg";